import { useRouter } from "next/router";
import queryString from "query-string";
import { useSelector } from "react-redux";

import FlightCombination from "shared/types/flightCombination";

import { policiesPassed } from "@components/Flights/TravelPolicies";

import { beginCheckoutDataLayer } from "@lib/dataLayers";
import { AppState } from "@shared/data/reducers";

type Props = {
  selectedCombination: FlightCombination;
  refs: string[];
  policyResolve?: any;
  brandCheckedBaggageService?: string;
  flightSource?: string;
  brandsDetailsAvailable?: boolean;
  flightOffer?: any;
  intl: any;
};

const useNthFlightLink = ({
  selectedCombination,
  refs,
  policyResolve,
  brandCheckedBaggageService,
  flightSource,
  brandsDetailsAvailable,
  flightOffer,
  intl,
}: Props): [string, () => void] => {
  const router = useRouter();

  const gtmId = useSelector(
    (state: AppState) =>
      state.storage.frontendSettings?.dealerGoogleSettings
        ?.tagManagerContainerId
  );

  const baggageLimit = selectedCombination.PricingDetail.BaggageLimit;

  let query: any = {
    refs,
    ...router.query,
    detailsAvailable: baggageLimit.DetailsAvailable,
    baggageLimitQuantity: baggageLimit?.Quantity_2 ?? baggageLimit.Quantity,
    baggageLimitWeight: baggageLimit?.Weight_2 ?? baggageLimit.Weight,
    baggageIncluded: brandCheckedBaggageService ?? null,
    flightSource: flightSource ?? null,
    brandsDetailsAvailable: brandsDetailsAvailable ?? false,
  };
  query = policyResolve?.Id
    ? { ...query, policyResolvedId: policyResolve.Id }
    : query;
  query =
    policyResolve && !policiesPassed(policyResolve?.Value || policyResolve)
      ? { ...query, policyFailed: true }
      : query;

  const flightUrl = queryString.stringifyUrl({
    url: "/result",
    query,
  });

  const openFlight = () => {
    if (gtmId) {
      beginCheckoutDataLayer(intl, {
        ...flightOffer,
      });
    }

    router.push({
      pathname: "/result",
      query,
    });
  };

  return [flightUrl, openFlight];
};

export default useNthFlightLink;
